import { motion, AnimatePresence } from "framer-motion";
import {
  FiUser,
  FiMail,
  FiMessageCircle,
  FiSend,
  FiCheck,
} from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";

import "./Form.scss";
import React from "react";

const Form = ({ setShowForm }) => {
  // NOTE: keeping original form logic names and state shape but not changing behavior
  const [formData, setFormData] = React.useState({
    username: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    // original logic preserved
    if (!username || !email || !message) {
      alert("All fields are required!");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("/.netlify/functions/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          email,
          message,
          title: "BBM Cybersecurity Training Request Form",
          subject: "New Training Request Submission",
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setIsFormSubmitted(true);
      } else {
        console.error("Email failed:", data.error);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    setLoading(false);
  };

  return (
    <motion.div
      className="training-form-card"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: "easeOut" }}
    >
      <div className="form-header">
        <div>
          <h3 className="form-title">Request for our training services</h3>
          <p className="form-sub">
            Tell us briefly what you need — we'll follow up.
          </p>
        </div>
        <div
          className="form-badge cursor-pointer"
          onClick={() => {
            setShowForm(false);
          }}
        >
          <AiOutlineClose />
        </div>
      </div>

      <AnimatePresence mode="wait">
        {!isFormSubmitted ? (
          <motion.form
            className="form-body"
            key="form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <label className="field">
              <FiUser className="field-ico" />
              <input
                type="text"
                name="username"
                placeholder="Your name"
                value={username}
                onChange={handleChangeInput}
                className="field-input"
                aria-label="Your name"
              />
            </label>

            <label className="field">
              <FiMail className="field-ico" />
              <input
                type="email"
                name="email"
                placeholder="Your email"
                value={email}
                onChange={handleChangeInput}
                className="field-input"
                aria-label="Your email"
              />
            </label>

            <label className="field field-area">
              <FiMessageCircle className="field-ico field-ico-top" />
              <textarea
                name="message"
                placeholder="Tell us what training you’re interested in"
                value={message}
                onChange={handleChangeInput}
                className="field-input textarea"
                rows={4}
                aria-label="Training message"
              />
            </label>

            <motion.button
              type="submit"
              className="submit-btn"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span>Sending...</span>
                </>
              ) : (
                <>
                  <FiSend className="btn-ico" /> <span>Send Request</span>
                </>
              )}
            </motion.button>
          </motion.form>
        ) : (
          <motion.div
            className="submitted"
            key="submitted"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="submitted-ico">
              <FiCheck />
            </div>
            <div>
              <h4 className="submitted-title">Thank you!</h4>
              <p className="submitted-sub">
                🎉 Your request has been received. Our team will reach out soon.
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Form;
